/**
 * @generated SignedSource<<bedd24dc78235a7fc44aa763923e9edf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roles"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "roles",
        "variableName": "roles"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateRoles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateRolesMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateRolesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c44bb28bca64f9c9ae0ea8918684e2dd",
    "id": null,
    "metadata": {},
    "name": "UpdateRolesMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateRolesMutation(\n  $userId: ID!\n  $roles: [UserRoleInput!]!\n) {\n  updateRoles(userId: $userId, roles: $roles) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "7580ccb9948242d91bfdf85fe9046782";

export default node;
